import { createFileRoute } from '@tanstack/react-router';

import { StudentsClassPage } from '~features/students/index';

const Component = () => {
  const { studentId } = Route.useParams();
  return <StudentsClassPage studentId={studentId} />;
};

export const Route = createFileRoute('/_auth/_layout/students/$studentId/classes')({
  component: Component,
});
